import { useTheme } from "@/context/ThemeContext";
import { READING_STYLES, type ReadingStyle } from "@/lib/themes";

const READING_LABELS: Record<ReadingStyle, string> = {
  standard: "Standard",
  simplified: "Simplified",
};
const READING_HINTS: Record<ReadingStyle, string> = {
  standard: "Editorial copy as written.",
  simplified: "Plain-language versions of long descriptions and verification results.",
};

// Mirrors the visual style of Paper Texture / Text Size / Vision Mode
// segmented controls in ThemeStudio + VisionAccessibilitySections.
export function ReadingStyleSection() {
  const { prefs, setPrefs } = useTheme();

  return (
    <div role="radiogroup" aria-labelledby="reading-style-label">
      <div
        id="reading-style-label"
        className="caps"
        style={{
          color: "hsl(var(--ink-2))",
          marginBottom: 8,
          display: "flex",
          alignItems: "center",
        }}
      >
        Reading style
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {READING_STYLES.map((id, i) => {
          const active = prefs.readingStyle === id;
          return (
            <button
              key={id}
              type="button"
              role="radio"
              aria-checked={active}
              aria-label={`Reading style: ${READING_LABELS[id]}`}
              onClick={() => {
                if (prefs.readingStyle !== id) void setPrefs({ readingStyle: id });
              }}
              style={{
                flex: 1,
                padding: "10px 12px",
                background: active ? "hsl(var(--ink))" : "hsl(var(--cream))",
                color: active ? "hsl(var(--ink-fg))" : "hsl(var(--ink))",
                border: "1px solid hsl(var(--ink))", borderRadius: 999,
                cursor: "pointer",
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 10,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                minHeight: 44,
              }}
            >
              {READING_LABELS[id]}
            </button>
          );
        })}
      </div>
      <div
        style={{
          marginTop: 6,
          fontFamily: "'Fraunces', 'Playfair Display', serif",
          fontSize: 11,
          color: "hsl(var(--ink-2))",
          lineHeight: 1.35,
        }}
      >
        {READING_HINTS[prefs.readingStyle]}
      </div>
    </div>
  );
}